import { EventEmitter } from '../core';
import Peer from '../core/Peer';

class PeerStore extends EventEmitter {
  private static _instance: PeerStore;
  public static get instance(): PeerStore {
    if (!PeerStore._instance) {
      PeerStore._instance = new PeerStore();
    }

    return PeerStore._instance;
  }

  public peer: Peer;

  constructor() {
    super();

    this.peer = new Peer();
  }
}

export default PeerStore;
